"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _actions = require("../../actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function BriefsHelperMessage(_ref) {
  var page = _ref.page,
      message = _ref.message;
  var dispatch = (0, _reactRedux.useDispatch)();
  var visible = (0, _reactRedux.useSelector)(function (state) {
    return state.campaignCreator.helperMessage[page];
  });

  function handleSetMessageDisplay() {
    dispatch((0, _actions.setHelperMessageVisibility)(page, false));
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    className: "briefs-helper--wrapper__" + page,
    style: {
      display: visible ? 'flex' : 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    style: {
      backgroundColor: '#647080',
      color: 'white',
      paddingLeft: '12px',
      paddingRight: '12px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 10
  }, message), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 2,
    style: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    className: "briefs-helper--button",
    onClick: handleSetMessageDisplay
  }, "Ok, got it"))));
}

var _default = BriefsHelperMessage;
exports["default"] = _default;